import type { Device } from "./entities.ts";

// SS-EN 81346 — stadgad prefix per deviceKind.
// Kunden kan override:a per symbol i SymbolDefinition.designationPrefix,
// men dessa är sunda defaults.
export const DESIGNATION_PREFIXES: Readonly<Record<string, string>> = {
  contactor: "K",
  relay: "K",
  circuit_breaker: "Q",
  disconnector: "Q",
  fuse: "F",
  motor_protector: "Q",
  motor: "M",
  generator: "G",
  transformer: "T",
  meter: "P",
  indicator_light: "H",
  push_button: "S",
  switch: "S",
  sensor: "B",
  resistor: "R",
  capacitor: "C",
  inductor: "L",
  connector: "X",
  terminal: "X",
  cable: "W",
  conductor: "W",
  earth: "PE",
  surge_protector: "F",
  power_supply: "G",
};

const DESIGNATION_RE = /^(?<prefix>[A-Za-z]+)(?<num>\d+)$/;

export function parseDesignation(d: string): { prefix: string; num: number } | null {
  const m = DESIGNATION_RE.exec(d);
  if (!m?.groups) return null;
  const prefix = m.groups["prefix"];
  const numRaw = m.groups["num"];
  if (!prefix || !numRaw) return null;
  return { prefix, num: Number.parseInt(numRaw, 10) };
}

/**
 * Returnerar nästa lediga designation för en given prefix över devices på ett sheet
 * (eller globalt om sheetDevices = alla). Hittar högsta nummer för prefixen, +1.
 */
export function nextDesignation(
  prefix: string,
  existingDevices: Iterable<Pick<Device, "designation">>,
): string {
  let max = 0;
  for (const d of existingDevices) {
    const parsed = parseDesignation(d.designation);
    if (!parsed) continue;
    if (parsed.prefix === prefix && parsed.num > max) max = parsed.num;
  }
  return `${prefix}${max + 1}`;
}

export function prefixFor(deviceKind: string, override?: string): string {
  if (override) return override;
  return DESIGNATION_PREFIXES[deviceKind] ?? "U";
}
